export default __webpack_public_path__ + "static/media/prx-dumbles.f2e4a778.webp";